import { render, staticRenderFns } from "./BackBtn.vue?vue&type=template&id=203878db"
import script from "./BackBtn.vue?vue&type=script&lang=js"
export * from "./BackBtn.vue?vue&type=script&lang=js"
import style0 from "./BackBtn.vue?vue&type=style&index=0&id=203878db&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports